import apiClient from './client'
import type { AuthMeResponse } from '@/types/auth'

export const authApi = {
    me: async (): Promise<AuthMeResponse> => {
        const response = await apiClient.get<AuthMeResponse>('/auth/mi')

        return response.data
    },
}
